import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/runner/work/business-command-center/business-command-center/ADG2_Transport/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["NavBar"] */ "/home/runner/work/business-command-center/business-command-center/ADG2_Transport/src/components/Layout/NavBar.tsx");
